export const RE_CUSTOM_FIELD_EDITOR = "RECustomFieldEditor";
export const RE_ADVANCED_PRICING = "REAdvancedPricing";
